export default "__VITE_ASSET__BN89FMl3__"